const refs = {
	switchers: document.querySelectorAll('[data-role="switcher"]'),
	switchersLabels: document.querySelectorAll('[data-role="switcher-label"]'),
	dialog: document.querySelector('[data-role="select-dialog"]'),
	hiddenDialogOpener: document.querySelector('[data-role="hidden-dialog-opener"]'),
	dialogOpener: document.querySelector('[data-role="dialog-opener"]'),
	dialogCloser: document.querySelector('[data-role="dialog-closer"]'),
	progressbarCheckpoints: document.querySelectorAll('[data-role="progress--checkpoint"]'),
	progressbar: document.querySelector('[data-role="progressbar"]'),
	quantityInputs: document.querySelectorAll('[data-role="quantity-input"]'),
	atcButton: document.querySelector('[data-role="atc"]'),
	cartOpener: document.getElementById('cart-icon-bubble'),
	totalComparePrice: document.querySelector('[data-role="compare-at-total-price"]'),
	totalPrice: document.querySelector('[data-role="total-price"]'),
}

const params = new URLSearchParams(window.location.search);
const variant = params.get('variant');


let totalProductQuantity = 0;
const openDialog = () => {
	refs.dialog.classList.add('open');
}
const closeDialog = () => {
	refs.dialog.classList.remove('open');
}
// openDialog();

const setProgress = () => {
	refs.progressbarCheckpoints.forEach((checkpoint) => {
		const checkpointValue = +checkpoint.dataset.point;

		if (checkpointValue <= totalProductQuantity) checkpoint.classList.add('accent');
		else checkpoint.classList.remove('accent');
	})

	refs.progressbar.style.width = `${totalProductQuantity !== 0 ? (Math.min(totalProductQuantity, 3) / 3) * 100 : 0}%`;
	refs.atcButton.disabled = totalProductQuantity >= 3 ? false : true;

	const inputs = Array.from(refs.quantityInputs).filter(input => input.value !== '0')

	const prices = []

	for (const input of inputs) {
		const value = +input.value

		for (let index = 1; index <= value; index++) {
			prices.push(+input.dataset.price)
		}
	}

	const compareAtPrice = prices.reduce((acc, price) => acc + price, 0);
	const pricesCopy = [...prices]
	const elemsToRemove = Math.floor(prices.length / 3)


	for (let i = 0; i < elemsToRemove; i++) {
		const minIndex = pricesCopy.indexOf(Math.min(...pricesCopy))
		pricesCopy.splice(minIndex, 1);
	}

	const totalPrice = totalProductQuantity < 3 ? compareAtPrice : pricesCopy.reduce((acc, price) => acc + price, 0)

	refs.totalComparePrice.innerHTML = totalProductQuantity < 3 ? '' : `€${compareAtPrice.toFixed(2)}`
	refs.totalPrice.innerHTML = `€${totalPrice.toFixed(2)}`
}

if (refs.switchers.length > 0)
	refs.switchers.forEach(switcher => {
		const { value } = switcher;
		console.log({ variant, value });

		if (variant === value) switcher.click();

		switcher.addEventListener("change", e => {
			e.preventDefault();
			e.stopPropagation();

			const { details } = e.currentTarget.dataset;


			if (details) refs.hiddenDialogOpener.classList.remove("visually-hidden")
			else refs.hiddenDialogOpener.classList.add("visually-hidden")

			if (value && value !== '') {
				const hiddenInputs = e.currentTarget.closest("section").querySelectorAll('.product__info-container form[data-type="add-to-cart-form"] input[name="id"]');
				console.log({hiddenInputs})
				hiddenInputs.forEach(input => {
					input.value = value;
				}) 

				params.set('variant', value);
				const newUrl = `${window.location.pathname}?${params.toString()}`;
				window.history.replaceState({}, '', newUrl);

				const { origin, pathname } = window.location;
				console.log({ origin, pathname });

				fetch(`${origin + pathname}?variant=${value}`)
					.then((response) => response.text())
					.then((responseText) => {
						const html = new DOMParser().parseFromString(responseText, 'text/html');

						const documentPrices = document.querySelector(".product__price-container");
						const htmlPrices = html.querySelector(".product__price-container");

						documentPrices.replaceWith(htmlPrices.cloneNode(true));

					})
			}


		})
	})

refs.dialog.addEventListener("click", e => {
	if (e.target === e.currentTarget) closeDialog();
})

refs.hiddenDialogOpener.addEventListener('click', (e) => {
	e.stopImmediatePropagation();
	e.preventDefault();

	openDialog()
});
refs.dialogOpener.addEventListener('click', () => {
	openDialog()
});

refs.dialogCloser.addEventListener('click', () => {
	closeDialog();
});

refs.atcButton.addEventListener('click', () => {
	const qtyInputs = Array.from(refs.quantityInputs).filter(input => input.value !== '0').map(input => {
		return {
			id: input.dataset.id,
			quantity: input.value,
		}
	});

	const formData = {
		items: qtyInputs
	};

	fetch(window.Shopify.routes.root + 'cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(formData),
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error(`Error ${response.statusText}`);
			}
			console.log('Product was added to cart', response);

			refreshCart();
		})
		.catch((error) => {
			console.error('Error:', error);
			alert(`Something went wrong. Please try again. Error ${error?.message}`);
		})
})

class NumberInput extends HTMLElement {
	constructor() {
		super();

		this.input = this.querySelector('[type="number"]');
		this.step = +this.input.getAttribute('step') || 1;
		this.min = +this.input.min || 0;
		this.max = +this.input.max || Infinity;

		this.changeEvent = new Event('change', {
			bubbles: true,
		});

		this.plus = this.querySelector('[is-plus]');
		this.minus = this.querySelector('[is-minus]');

		this.plus.addEventListener('click', () => {
			this.updateValue(this.step);

			totalProductQuantity = totalProductQuantity + 1
			setProgress();
		});
		this.minus.addEventListener('click', () => {
			this.updateValue(-this.step);

			if (totalProductQuantity <= 0) return;
			totalProductQuantity = totalProductQuantity - 1
			setProgress();
		});
		this.input.addEventListener('change', () => {
			this.validateManualInput();
		});
	}

	updateValue(change) {
		const currentValue = this.input.valueAsNumber || this.min;
		let newValue = currentValue + change;

		if (newValue < this.min) newValue = this.min;
		if (newValue > this.max) newValue = this.max;

		const decimals = (this.step.toString().split('.')[1] || '').length;
		newValue = +newValue.toFixed(decimals);

		this.input.value = newValue;

		if (newValue === 0) this.classList.add('unsetted');
		else this.classList.remove('unsetted');
	}

	validateManualInput() {
		let currentValue = this.input.valueAsNumber;
		currentValue = this.adjustToStep(currentValue);

		if (currentValue < this.min) currentValue = this.min;
		if (currentValue > this.max) currentValue = this.max;

		const decimals = (this.step.toString().split('.')[1] || '').length;
		currentValue = +currentValue.toFixed(decimals);

		this.input.value = currentValue;
	}

	adjustToStep(value) {
		const min = isFinite(this.min) ? this.min : 0.5;
		const diff = value - min;
		const steps = Math.round(diff / this.step);
		const adjusted = min + steps * this.step;

		const decimals = (this.step.toString().split('.')[1] || '').length;
		return +adjusted.toFixed(decimals);
	}
}

if (!customElements.get('number-input')) {
	customElements.define('number-input', NumberInput);
}

function refreshCart() {
	let sections = 'cart-drawer';

	fetch(`${window.location.pathname}?sections=${sections}`)
		.then((response) => {
			return response.text();
		})
		.then((state) => {
			const parsedState = JSON.parse(state);

			getSectionsToRender().forEach((section) => {
				const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

				if (elementToReplace) elementToReplace.innerHTML = getSectionInnerHTML(parsedState[section.section], section.selector);
			});
		}).finally(() => {
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
			closeDialog();
			refs.cartOpener.click();

			document.getElementById('CartDrawer-Overlay').addEventListener("click", e => {
				e.currentTarget.closest('cart-drawer').classList.remove('active');
				document.body.classList.remove('overflow-hidden');
			});
		});
}

function getSectionsToRender() {
	return [
		{
			id: 'CartDrawer',
			section: 'cart-drawer',
			selector: '.cart-drawer',
		},
		{
			id: 'Cart',
			section: 'main-cart',
			selector: '.thb-cart-form',
		},
		// {
		// 	id: 'cart-icon-bubble',
		// 	section: 'cart-bubble',
		// 	selector: '.thb-item-count',
		// },
	];
}
function getSectionInnerHTML(html, selector) {
	return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}
